/**
 * Stop Time Analysis Service
 * API client för stopptidsanalys
 */

import api from '../api/client';
import { StopTimeAnalysisResult } from '@/types/analysis';

export interface StopTimeAnalysisParams {
  startDate?: string; // YYYY-MM-DD
  endDate?: string; // YYYY-MM-DD
  organizationId?: string;
  vehicleIds?: string[];
}

export const stopTimeAnalysisService = {
  /**
   * Hämta stopptidsanalys
   */
  async getStopTimeAnalysis(
    params: StopTimeAnalysisParams
  ): Promise<StopTimeAnalysisResult> {
    const queryParams = new URLSearchParams();
    
    if (params.startDate) {
      queryParams.append('startDate', params.startDate);
    }
    if (params.endDate) {
      queryParams.append('endDate', params.endDate);
    }
    if (params.organizationId) {
      queryParams.append('organizationId', params.organizationId);
    }
    if (params.vehicleIds && params.vehicleIds.length > 0) {
      queryParams.append('vehicleIds', params.vehicleIds.join(','));
    }

    const response = await api.get<{ success: boolean; data: StopTimeAnalysisResult }>(
      `/api/analysis/stop-time?${queryParams.toString()}`,
      { timeout: 120000 }
    );

    if (!response.data.success) {
      throw new Error('Failed to fetch stop time analysis');
    }

    return response.data.data;
  },
};

